<div class="my-4 mx-5">
    <div class="wrapper mb-2">
        <div class="row align-items-center m-0 mb-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Vincular Cartão ao Portador</span>
        </div>
        <!-- <div class="my-0 alert alert-light" role="alert">
            <div class="row p-3">
                <div class="p-0 mx-3 align-self-center">
                    <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
                </div>
                <div class="col-11 p-0 m-0 align-self-center">
                    <p class="m-0">
                        <strong>Quando ultilizar esse procedimento:</strong>
                        <br>Somente utilize este procedimento caso o favorecido em questão não possua acesso a smartphone para ativar o cartão através do aplicativo Bankei Beneflex, disponível gratuitamente nas lojas do Google Play e Apple Store.
                    </p>
                </div>
            </div>
        </div> -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-6 p-3">
                    <div class="container-fluid">
                        <div class="container-fluid component-box">
                            <form [formGroup]="cardDataFormGroup" class="p-4">
                                <mat-form-field>
                                <mat-label>Número do cartão</mat-label>
                                <input matInput name="cardNumber" formControlName="cardNumber" placeholder="0000 0000 0000 0000" [textMask]="{mask: cardmask}" (blur)="getPan(cardDataFormGroup.get('cardNumber').value)">
                                </mat-form-field>
                                <mat-error *ngIf="(cardDataFormGroup.get('cardNumber').invalid && (cardDataFormGroup.get('cardNumber').dirty || cardDataFormGroup.get('cardNumber').touched)) && cardDataFormGroup.get('cardNumber').errors.required">
                                    Número do cartão é obrigatório!
                                </mat-error>
                                <mat-error *ngIf="!isValidPan && showErrorPan && cardDataFormGroup.get('cardNumber').valid">
                                    Número do cartão é inválido!
                                </mat-error>
                                <mat-error *ngIf="!canBindNewUser && showErrorBindNewUser && cardDataFormGroup.get('cardNumber').valid">
                                    Esse número do cartão já está sendo utilizado!
                                </mat-error>
                                <table class="w-100" cellspacing="0" *ngIf="isValidPan && canBindNewUser">
                                    <tr>
                                        <td>
                                            <mat-form-field class="w-75">
                                                <mat-label>CVV</mat-label>
                                                <input matInput formControlName="cvv" placeholder="000" maxlength="3">
                                            </mat-form-field>
                                            <mat-error *ngIf="(cardDataFormGroup.get('cvv').invalid && (cardDataFormGroup.get('cvv').dirty || cardDataFormGroup.get('cvv').touched)) && cardDataFormGroup.get('cvv').errors.required">
                                                CVV é obrigatório!
                                            </mat-error>
                                        </td>
                                        <td>
                                            <mat-form-field class="w-75">
                                                <mat-label>Data de Validade</mat-label>
                                                <input matInput formControlName="expirationDate" placeholder="MM/YY" [textMask]="{mask: datemask}">
                                            </mat-form-field>
                                            <mat-error *ngIf="(cardDataFormGroup.get('expirationDate').invalid && (cardDataFormGroup.get('expirationDate').dirty || cardDataFormGroup.get('expirationDate').touched)) && cardDataFormGroup.get('expirationDate').errors.required">
                                                Data de Validade é obrigatório!
                                            </mat-error>
                                        </td>
                                    </tr>
                                </table>
                                <table class="w-100" cellspacing="0" *ngIf="isValidPan && canBindNewUser">
                                    <tr>
                                        <td>
                                            <mat-form-field class="w-75">
                                                <mat-label>Senha do cartão</mat-label>
                                                <input matInput formControlName="cardPin" type="password" maxlength="4" onlyNumber>
                                            </mat-form-field>
                                            <mat-error *ngIf="(cardDataFormGroup.get('cardPin').invalid && (cardDataFormGroup.get('cardPin').dirty || cardDataFormGroup.get('cardPin').touched)) && cardDataFormGroup.get('cardPin').errors.required">
                                                A senha do cartão é obrigatória!
                                            </mat-error>
                                            <mat-error *ngIf="(cardDataFormGroup.get('cardPin').invalid && (cardDataFormGroup.get('cardPin').dirty || cardDataFormGroup.get('cardPin').touched)) && (cardDataFormGroup.get('cardPin').errors.minlength && cardDataFormGroup.get('cardPin').errors.maxlength)">
                                                A senha deve conter 4 dígitos
                                            </mat-error>
                                        </td>
                                        <td>
                                            <mat-form-field class="w-75">
                                                <mat-label>Confirmação senha</mat-label>
                                                <input matInput formControlName="cardPinConfirm" type="password" maxlength="4" onlyNumber>
                                            </mat-form-field>
                                            <mat-error *ngIf="(cardDataFormGroup.get('cardPinConfirm').invalid && (cardDataFormGroup.get('cardPinConfirm').dirty || cardDataFormGroup.get('cardPinConfirm').touched)) && cardDataFormGroup.get('cardPinConfirm').errors.required">
                                                A senha de confirmação é obrigatória
                                            </mat-error>
                                            <mat-error *ngIf="(cardDataFormGroup.get('cardPinConfirm').invalid && (cardDataFormGroup.get('cardPinConfirm').dirty || cardDataFormGroup.get('cardPinConfirm').touched)) && cardDataFormGroup.get('cardPinConfirm').errors.mustMatch">
                                                As senhas devem coincidir
                                            </mat-error>
                                        </td>
                                    </tr>
                                </table>
                                <div class="row button-container mt-5 mb-3">
                                    <div class="col-12 text-right">
                                        <button type="submit" class="custom-button-full" [disabled]="!bindcard" (click)="bindCard()">
                                            Vincular
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-6 p-3">
                    <div class="container-fluid">
                    <div class="container-fluid component-box ">
                        <div class="p-4">
                            <h5>Informações de ajuda</h5>
                            <br>
                            <p>Para ser feita a vincução do cartão físico precisaremos de algumas informações.</p>
                            <br>
                            <ul>
                                <li>
                                    É necessário que insira o número do cartão, cvv e data de validade.
                                </li>
                                <li>
                                    A senha será definida no momento da vinculação, anote a senha para distribui-lá para seus portadores.
                                </li>
                                <!-- <li>
                                    Se o veículo já tem um cartão vinculado, o atual será desativado.
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
